import { useParams } from 'react-router-dom';
import { FormContent } from './FormContent';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (options: {
          region: string;
          portalId: string;
          formId: string;
          target: string;
        }) => void;
      };
    };
  }
}

export const FormsScreen = () => {
  const { form } = useParams();

  return (
    <>
      <HeaderAndFooterLayout
        headerVisible={true}
        footerVisible={true}
        footerShowSupportCta={true}
        isLoading={false}
      >
        <div className="forms-container">
          <FormContent form={form} redirectHomeOnMissingForm />
        </div>
      </HeaderAndFooterLayout>
    </>
  );
};
